export const STAGE = {
  UPLOAD_FILE: 'UPLOAD_FILE',
  WIZARD: 'WIZARD',
};
